/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOptions } from './common';
import { entityService } from './services';

const pathname = '/invitation-products';

export const InvitationProductApi = {
  find: async (options: FindOptions) => {
    let url = pathname;
    const query = serialize(options);
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findForUpdateInvitation: async (options: any) => {
    let url = `${pathname}/find-for-update-invitation`;
    const query = serialize(options);
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};
